module.exports = __webpack_public_path__ + "static/media/reprise.da0ea1ad.svg";